import {
  CLEAR_LEAD, GET_LEAD, SET_LEAD, SET_LEAD_VIEW,
  SET_LEAD_DOCUMENTS, SET_LEAD_ACTIVITY, SET_LEAD_NOTES,
} from '../actions/actionTypes';

const initialState = {
  data: {
    id: '',
  },
  documents: [],
  activity: [],
  notes: [],
  isLoading: false,
  isLoaded: false,
  view: 'ACTIVITY'
};

const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD:
      return { ...state, isLoading: true };
    case SET_LEAD:
      return {
        ...state,
        data: action.lead,
        isLoaded: true,
        isLoading: false
      };
    case SET_LEAD_DOCUMENTS:
      return {
        ...state,
        documents: action.documents,
      };
    case SET_LEAD_ACTIVITY:
      return {
        ...state,
        activity: action.activity,
      };
    case SET_LEAD_NOTES:
      return {
        ...state,
        notes: action.notes,
      };
    case CLEAR_LEAD:
      return initialState;
    case SET_LEAD_VIEW:
      return { ...state, view: action.view };
    default:
      return state;
  }
};

export default leadReducer;
